import FieldId from "../../fields/FieldId";
import { fields } from "../../fields/fields";
import FieldValueReference from "../../fields/FieldValueReference";
import type { FieldType } from "../../types";
import { FIELD_TYPES } from "../../types";
import { getIconCategoryColor } from "../iconColorUtil";
import toVariableDefinition from "../../variables/toVariableDefinition";
import { VARIABLE_TYPES, type VariableType } from "../../variables/types";
import VariableId from "../../variables/VariableId";
import VariableValueReference from "../../variables/VariableValueReference";
import type { DynamicValueIcon, DynamicValueId, DynamicValueType } from "../../types/Menu";
import type { MetaVariableId } from "../../metaVariables/metaVariable";
import { isMetaVariable, META_VARIABLES } from "../../metaVariables/metaVariable";

export const getDynamicValueIcon = (value: DynamicValueId, type: DynamicValueType): DynamicValueIcon | null => {
  if ((value instanceof FieldId || value instanceof FieldValueReference) && FIELD_TYPES.includes(type)) {
    const field = fields[type as FieldType];
    const color = getIconCategoryColor(field.category);
    return { name: field.icon, class: color };
  }

  if ((value instanceof VariableId || value instanceof VariableValueReference) && VARIABLE_TYPES.includes(type)) {
    const variable = toVariableDefinition(type as VariableType);
    return {
      name: variable.icon,
      class: "icon-primary bg-surface-subtle",
    };
  }

  if (isMetaVariable(type)) {
    return {
      name: META_VARIABLES[type as MetaVariableId].icon,
      class: "icon-primary bg-surface-subtle",
    };
  }

  return null;
};
